var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hide)?_c('div',{staticClass:"validator",attrs:{"valid":_vm.valid,"invalid":!_vm.valid}},_vm._l((_vm.errors),function(e){return _c('span',{key:e,staticClass:"errors__error"},[_c('img',{attrs:{"src":require("@/assets/error.svg")}}),_vm._v(" "+_vm._s(_vm.v_chain[e].message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }